import { Icon } from '@monorepo/base/src/components/icon/icon';
import { useStores } from '@monorepo/controlled/src/hooks/use-stores';
import styles from './notifications-menu.module.scss';
import { observer } from 'mobx-react';
import { Menu } from '@monorepo/base/src/components/menu/menu';
import { Fragment, useEffect, useMemo, useState } from 'react';
import { Spacer } from '@monorepo/base/src/components/spacer/spacer';
import { INotificationItem } from '@monorepo/controlled/src/stores/notifications.store';
import { AvatarDetails, AvatarTitle, AvatarSubtitle } from '@monorepo/base/src/components/avatar-details/avatar-details';
import dayjs from 'dayjs';
import { IMFPStore } from '../../stores';
import { PublishingProgress } from './notifications/publishing-progress';
import { DispatchLogsTypes } from '@monorepo/controlled/src/hooks/use-logs';

export const NotificationsMenu = observer(() => {
	const { notificationsStore, userStore } = useStores<IMFPStore>();
	const notifications = notificationsStore.getNotifications();
	const isOpenMenu = useMemo(() => {
		return notificationsStore.getIsOpenMenu();
	}, [notificationsStore.getIsOpenMenu()]);
	const [, setIsBadge] = useState<boolean>(false);

	useEffect(() => {
		if (Array.isArray(notifications) && notifications.length > 0) {
			setIsBadge(true);
		}
	}, [notifications]);

	useEffect(() => {
		if (isOpenMenu) {
			setIsBadge(false);
		}
	}, [isOpenMenu]);

	const NotificationBar = () => {
		return (
			<Icon
				className={styles.notificationBell}
				color={'#8a8a8a'}
				size={'20px'}
				isMFP={true}
				onClick={() => {
					notificationsStore.setIsOpenMenu(!isOpenMenu);
				}}>
				bell-03
			</Icon>
		);
	};

	return (
		<div className={styles.wrapper}>
			<NotificationBar />
			<Menu
				unstyled={true}
				isOpen={isOpenMenu}
				onClose={() => {
					notificationsStore.setIsOpenMenu(false);
				}}
				alignToRight={true}>
				<div className={styles.notificationsMenu}>
					<div className={styles.title}>Notifications</div>
					<Spacer y={1} />
					{!notifications || notifications.length === 0 ? (
						<div className={styles.noting}>Nothing new here</div>
					) : (
						notifications.map((notification: INotificationItem, index) => {
							const { msg, children, date, type, id, extraData } = notification;

							return (
								<Fragment key={date.toString() + msg}>
									<AvatarDetails url={userStore.getUser()?.getPicture()}>
										{type !== DispatchLogsTypes.PublishingProgress ? (
											<AvatarTitle>{msg || children}</AvatarTitle>
										) : (
											<PublishingProgress notificationId={id} {...extraData} />
										)}
										<AvatarSubtitle>{dayjs(date).format('DD-MM-YYYY HH:MM')}</AvatarSubtitle>
									</AvatarDetails>
									{index + 1 !== notifications.length ? <Spacer y={2} /> : null}
								</Fragment>
							);
						})
					)}
				</div>
			</Menu>
		</div>
	);
});
